export enum ApiCollectionExportFormat {
  Postman = 'Postman',
  Bruno = 'Bruno',
}

export interface ApiCollectionFile {
  fileName: string;
  content: string;
  contentType: string;
}

export interface ApiCollectionVariables {
  clientId: string;
  clientSecret: string;
  resource: string;
  baseUrl: string;
  tokenEndpoint: string;
}

export const defaultApiCollectionVariables = {
  clientId: '{{clientId}}',
  clientSecret: '{{clientSecret}}',
  resource: '{{resource}}',
  baseUrl: '{{baseUrl}}',
  tokenEndpoint: '{{tokenEndpoint}}',
} satisfies ApiCollectionVariables;

export const httpMethods = ['get', 'put', 'post', 'delete', 'options', 'head', 'patch', 'trace'] as const;

export type OpenApiHttpMethod = (typeof httpMethods)[number];

export interface OpenApiCollectionParameter {
  name: string;
  value: string;
  description?: string;
}

export type OpenApiCollectionRequestBody =
  | {
      mode: 'none';
    }
  | {
      mode: 'raw';
      value: string;
      contentType: string;
    }
  | {
      mode: 'formUrlEncoded';
      parameters: OpenApiCollectionParameter[];
      contentType: 'application/x-www-form-urlencoded';
    };

export interface OpenApiCollectionRequest {
  id: string;
  name: string;
  method: Uppercase<OpenApiHttpMethod>;
  path: string;
  url: string;
  description?: string;
  queryParameters: OpenApiCollectionParameter[];
  pathParameters: OpenApiCollectionParameter[];
  body: OpenApiCollectionRequestBody;
  tags: string[];
}
